<template>
  <exo-help-dialog title="Line losses">
    <p>
      In both the RF transmitter and receivers, the physical components used in
      the systems introduce some loss in the signal. This can come mainly from
      the cables (dependant on cable type, length and operating frequency),
      connectors and antenna mismatching. In space<strong>studio</strong>, you
      can directly input the sum of all those elements as "line losses".
    </p>
    <p>
      For a transmitter, the line losses will be used to compute the
      <katex-element expression="\mathrm{EIRP}" />.
    </p>
    <tooltipEquationEIRP />
    <p>
      For a receiver, the line losses will be used to compute the
      <katex-element expression="G/T" />.
    </p>
    <tooltipEquationGT />
    <tooltipEquationEbN0 />
  </exo-help-dialog>
</template>

<script>
import tooltipEquationEbN0 from './tooltipEquationEbN0.vue'
import tooltipEquationEIRP from './tooltipEquationEIRP.vue'
import tooltipEquationGT from './tooltipEquationGT.vue'
export default {
  name: 'tooltipLineLosses',
  components: {
    tooltipEquationEbN0,
    tooltipEquationEIRP,
    tooltipEquationGT
  }
}
</script>
